<template>
  <div class="c-adminAllocation" id="admin-meeting-index">
    <PageTitle titleText="申込マスタ管理"></PageTitle>
    <p class="c-adminAllocation__buttonWrap">
      <el-button type="primary" icon="el-icon-circle-plus" @click="onEdit()"
        >申込追加</el-button
      >
    </p>
    <el-table :data="docs" stripe style="width: 100%">
      <el-table-column label="名称" prop="name" sortable></el-table-column>
      <el-table-column
        label="タイプ"
        width="120"
        prop="type"
        sortable
      ></el-table-column>
      <el-table-column
        label="期間"
        width="300"
        prop="reception_range.0"
        sortable
      >
        <template slot-scope="scope">
          <span style="margin-left: 10px"
            >{{
              scope.row.reception_range[0] | moment("YYYY-MM-DD HH:mm")
            }}&nbsp;〜&nbsp;{{
              scope.row.reception_range[1] | moment("YYYY-MM-DD HH:mm")
            }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="ステータス"
        width="120"
        prop="status"
        sortable
      ></el-table-column>
      <el-table-column fixed="right" label="操作" fit="true" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onEdit(scope.row._id)"
            >編集</el-button
          >
          <el-button type="text" size="small" @click="onLottey(scope.row._id)"
            >抽選</el-button
          >
          <el-button type="text" size="small" @click="onRmove(scope.row._id)"
            >削除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import AllocationService from "@/services/allocation.service";
import Admin from "../../../mixin/guard/admin";
// import store from "../../../store";
import PageTitle from "@/components/PageTitle.vue";
export default {
  mixins: [Admin],
  components: {
    PageTitle,
  },
  data() {
    return {
      docs: [],
    };
  },
  async mounted() {
    await this.loadAllocations();
  },
  methods: {
    onLottey(id) {
      this.$router.push({
        name: "admin-allocation-lottery-index",
        params: { allocation_id: id },
      });
    },
    async loadAllocations() {
      const result = await AllocationService.find({
        where: {
          mansion: this.currentUser.mansion._id,
        },
      });
      this.docs = result.data;
      console.log(this.docs);
    },
    onEdit(id) {
      console.log(id);
      this.$router.push({
        name: "admin-allocation-edit",
        params: { allocation_id: id },
      });
    },
    async onRmove(_id) {
      if (!confirm("削除しても良いですか？")) {
        return;
      }
      // eslint-disable-next-line
      const result = await AllocationService.delete(_id);
      this.$message({
        type: "success",
        message: "削除しました",
      });
      this.loadAllocations();
    },
  },
};
</script>
../../../mixin/guard/admin
